/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentStatus } from './PaymentStatus';
import {
    PaymentStatusFromJSON,
    PaymentStatusFromJSONTyped,
    PaymentStatusToJSON,
    PaymentStatusToJSONTyped,
} from './PaymentStatus';

/**
 * 
 * @export
 * @interface InvoiceTotals
 */
export interface InvoiceTotals {
    /**
     * 
     * @type {PaymentStatus}
     * @memberof InvoiceTotals
     */
    status: PaymentStatus;
    /**
     * 
     * @type {number}
     * @memberof InvoiceTotals
     */
    totalQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceTotals
     */
    totalAmount: number;
}



/**
 * Check if a given object implements the InvoiceTotals interface.
 */
export function instanceOfInvoiceTotals(value: object): value is InvoiceTotals {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('totalQuantity' in value) || value['totalQuantity'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    return true;
}

export function InvoiceTotalsFromJSON(json: any): InvoiceTotals {
    return InvoiceTotalsFromJSONTyped(json, false);
}

export function InvoiceTotalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceTotals {
    if (json == null) {
        return json;
    }
    return {
        
        'status': PaymentStatusFromJSON(json['status']),
        'totalQuantity': json['totalQuantity'],
        'totalAmount': json['totalAmount'],
    };
}

export function InvoiceTotalsToJSON(json: any): InvoiceTotals {
    return InvoiceTotalsToJSONTyped(json, false);
}

export function InvoiceTotalsToJSONTyped(value?: InvoiceTotals | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': PaymentStatusToJSON(value['status']),
        'totalQuantity': value['totalQuantity'],
        'totalAmount': value['totalAmount'],
    };
}

